import React from 'react'
import PropTypes from 'prop-types'

import SVG from './../SVG'

import './Button.scss'

/**
 * Button Component
 */
const Button = ({
  children,
  className,
  icon,
  disabled,
  onClick,
  name,
  value,
  isFullWidth,
  ariaLabel,
  title
}) => {
  const handleClick = event => {
    !disabled && onClick(event)
  }

  return (
    <button
      disabled={disabled}
      className={`button ${className} ${isFullWidth ? 'is-fullwidth' : ''}`}
      onClick={handleClick}
      value={value}
      name={name}
      aria-label={ariaLabel}
      title={title}
    >
      {icon && <SVG>{icon}</SVG>}
      {children}
    </button>
  )
}

Button.propTypes = {
  /** onClick handler */
  onClick: PropTypes.func.isRequired,
  /** Label element or Icon element for button */
  children: PropTypes.node.isRequired,
  /** classes to change ui of button : is-primary|is-primary-outline */
  className: PropTypes.string,
  /** flag to make field enable|disable */
  disabled: PropTypes.bool,
  /** Action icon along with text */
  icon: PropTypes.node,
  /** flag to make to determine if button is full-width */
  isFullWidth: PropTypes.bool,
  ariaLabel: PropTypes.string,
  title: PropTypes.string
}

Button.defaultProps = {
  className: 'is-primary',
  disabled: false,
  icon: null,
  isFullWidth: false,
  ariaLabel: undefined,
  title: undefined
}

export default Button
